<div class="database-container">
    <div class="main-panel">
        <div #toolContainer class="filter-panel">
            <div #handleContainer class="position-controls">
                <div #resizeHandle class="resize">
                    <i class="fas fa-left-right resize-handle"></i>
                </div>
            </div>
            <div #toolDiv class="image-selection">
                <app-image-filter>
                </app-image-filter>
                <app-image-mosaic (selectedImage)="updateSelectedImage($event)">
                </app-image-mosaic>
            </div>
        </div>
        <div #viewerDiv class="viewer-container">
            <app-slide-viewer [image]="selectedImage" [slideListEnabled]="false" [classifyingEnabled]="false"
                [annotationsEnabled]="false"
                [heatmapEnabled]="false"
                [toolboxEnabled]="false"
                [slideListEnabled]="false"
                [enableNavigation]="false"
                [enableRuler]="false">
            </app-slide-viewer>
        </div>
    </div>
    <div class="mandatory-landscape" [ngClass]="{'hidden': !isPortrait}">
        <div class="inner-message">
            <span>{{ labels.USE_LANDSCAPE }}</span>
        </div>
    </div>
</div>